import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CloseDialogButtonComponent } from 'src/app/components/dialog/close-dialog-button/close-dialog-button.component';

export interface LiveEventDialogData {
  heroSrc: string;
  title?: string;
  body: string;
  /** RichText HTML for `body`; preferred when present. */
  bodyHtml?: string;
  ctaText: string;
  ctaRoute: string[];
}

@Component({
  selector: 'app-live-event-dialog',
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, CloseDialogButtonComponent],
  templateUrl: './live-event-dialog.component.html',
  styleUrls: ['./live-event-dialog.component.scss']
})
export class LiveEventDialogComponent {
  readonly heroSrc: string;
  readonly title?: string;
  readonly body: string;
  readonly bodyHtml?: string;
  readonly ctaText: string;
  private readonly ctaRoute: string[];

  constructor(
    public dialogRef: MatDialogRef<LiveEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: LiveEventDialogData,
    private router: Router,
  ) {
    this.heroSrc = data.heroSrc;
    this.title = data.title;
    this.body = data.body;
    this.bodyHtml = data.bodyHtml;
    this.ctaText = data.ctaText;
    this.ctaRoute = data.ctaRoute;
  }

  cta(): void {
    this.router.navigate(this.ctaRoute);
    this.dialogRef.close();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
